import axios from 'axios';
import type { PermissionsResponseDto, PermissionsResponse } from './types';
import { permissionsResponseDtoToModel } from './mapper';

export const getCurrentUserPermissions = (): Promise<PermissionsResponse> => {
  return axios
    .get<PermissionsResponseDto>('/api/v1/authorization/permissions')
    .then((response) => permissionsResponseDtoToModel(response.data));
};
